import {
  IPanelStyles,
  getTheme,
  mergeStyles,
  IDetailsListStyles,
  IDetailsRowStyles,
  getRTL,
  ILinkStyles,
  IButtonStyles,
  mergeStyleSets,
  IBreadcrumbStyles,
  IIconStyles,
  NeutralColors
} from "@fluentui/react";

const theme = getTheme();
export const panelStyles: Partial<IPanelStyles> = {
  // headerText: {
  //   fontWeight: FontWeights.regular,
  //   color: theme.palette.themeDarkAlt
  // }
};

export const linkIconStyles: IIconStyles = {
  root: {
    display: "flex",
    marginLeft: 6,
    marginRight: 6,
    fontSize: 16,
    color: theme.palette.themeDarkAlt
  }
}

export const profilePanelStyles: Partial<IPanelStyles> = {
  // headerText: panelStyles.headerText,
  header: { paddingLeft: 15, paddingRight: 15 },
  content: { paddingLeft: 15, paddingRight: 15 }
}

export const uploadPanelStyles: Partial<IPanelStyles> = {
  // ...panelStyles,
  content: { paddingTop: 10 },
  footer: {
    backgroundColor: "#fff"
  },
};

export const settingsIconClass = mergeStyles({
  // color: theme.palette.themeDarkAlt,
  color: NeutralColors.gray160,
  cursor: "pointer",
  paddingRight: 5,
  fontSize: 16
});

export const detailListStyles: Partial<IDetailsListStyles> = {
  root: {
    margin: "0 0 0 0",
    padding: "0px",
    MsOverflowStyle: "scrollbar"
  },
  headerWrapper: {
    paddingTop: 0
  }
};

export const detailRowStyles: Partial<IDetailsRowStyles> = {
  root: {
    fontSize: "14px",
    selectors: {
      ":hover": { fontSize: "14px" }
    }
  }
};

export const detailRowLinkStyles: ILinkStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    ":hover": {
      color: theme.palette.neutralPrimary,
      textDecoration: "underline"
    },
    maxWidth: "100%"
  }
};

export const detailRowPiiDetectedStyles: Partial<IDetailsRowStyles> = {
  root: {
    fontSize: "14px",
    backgroundColor: '#ffebe5',
    borderBottom: '1px solid rgb(255, 255, 255)',
    selectors: {
      ":hover": { backgroundColor: '#ffded4' }
    }
  }
};

export const detailRowPiiNotDetectedStyles: Partial<IDetailsRowStyles> = {
  root: {
    fontSize: "14px",
    backgroundColor: '#e7f9e6',
    borderBottom: '1px solid rgb(255, 255, 255)',
    selectors: {
      ":hover": { backgroundColor: '#dff6dd' }
    }
  }
};

export const detailRowPiiDetectedStylesCM: Partial<IDetailsRowStyles> = {
  root: {
    backgroundColor: '#ffebe5',
    borderBottom: '1px solid rgb(255, 255, 255)',
    selectors: {
      ":hover": { backgroundColor: '#ffded4' }
    }
  }
};

export const detailRowPiiNotDetectedStylesCM: Partial<IDetailsRowStyles> = {
  root: {
    backgroundColor: '#e7f9e6',
    borderBottom: '1px solid rgb(255, 255, 255)',
    selectors: {
      ":hover": { backgroundColor: '#dff6dd' }
    }
  }
};

export const clearButtonClass: string = mergeStyles({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  cursor: 'pointer',
  flexBasis: '32px',
  flexShrink: 0,
  padding: 0,
  margin: '-1px 0px',
  selectors: {
    '&:hover .ms-Button': {
      backgroundColor: theme.palette.neutralLighter,
    },
    '&:hover .ms-Button-icon': {
      color: theme.palette.neutralPrimary,
    },
    '.ms-Button': {
      borderRadius: getRTL(theme) ? '1px 0 0 1px' : '0 1px 1px 0',
    },
    '.ms-Button-icon': {
      color: theme.palette.neutralSecondary,
    },
  },
});

export const confirmDeleteButtonStyles: IButtonStyles = {
  root: {
    cursor: "unset",
  },
  rootHovered: {
    color: theme.palette.neutralPrimary,
  }
};

export const editFilePropertiesButtonStyles: IButtonStyles = {
  root: {
    paddingTop: 5,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0
  }
};

export const dropZoneStyles: React.CSSProperties = {
  borderWidth: 2,
  borderStyle: "dashed",
  borderColor: theme.palette.themeDarkAlt,
  boxSizing: "border-box"
}

export const dropZoneStyleSets = mergeStyleSets({
  dropzoneActive: {
    position: "relative",
    "*": {
      pointerEvents: "none"
    },
    ":after": {
      borderWidth: 2,
      borderStyle: "dashed",
      borderColor: theme.palette.themeDarkAlt,
      boxSizing: "border-box",
      content: '" "',
      display: "block",
      pointerEvents: "none",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 999
    }
  }
});

export const dragZoneStyleSets = mergeStyleSets({
  dragzoneActive: {
    position: "relative",
    "*": {
      pointerEvents: "none"
    },
    ":after": {
      borderWidth: 2,
      borderStyle: "dashed",
      borderColor: theme.palette.neutralSecondary,
      boxSizing: "border-box",
      content: '" "',
      display: "block",
      pointerEvents: "none",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 999
    }
  }
});

export const fileIconHeaderIcon: string = mergeStyles({
  padding: 0,
  fontSize: '16px'
});

export const brandedActionButtonIconStyles: string = mergeStyles({
  marginLeft: 2,
  marginRight: 2,
  height: 16,
  width: 16
});

export const brandedCommandbarIconStyles: string = mergeStyles({
  marginLeft: 4,
  marginRight: 4,
  height: 16,
  width: 16
});

export const menuItemIconStyles: string = mergeStyles({
  marginLeft: 2,
  marginRight: 2
});

export const breadCrumbContainerStyles: React.CSSProperties = {
  height: 25
}

export const breadCrumbStyles: Partial<IBreadcrumbStyles> = {
  root: {
    marginTop: 0,
    marginBottom: 0
  },
  chevron: {
    fontSize: 10,
  },
  item: {
    fontSize: 12,
    lineHeight: 20,
    paddingLeft: 2,
    paddingRight: 2
  },
  overflowButton: {
    selectors: {
      "@media only screen and (max-width: 479px) and (min-width: 0px)": { paddingLeft: 0, paddingRight: 0 },
      ":hover": { color: "#106ebe" }
    },
    paddingLeft: 0,
    paddingRight: 0
  }
};

export const previewWebPanelStyles: Partial<IPanelStyles> = {
  main: {
    overflow: "unset"
  },
  commands: {
    "@media all": {
      position: "relative",
      zIndex: 10
    }
  }
}